'use strict'

import ApiClient from './ApiClient'

export default class LibRepository {
  /**
   * 郵便番号からの住所検索。
   * @param {string} zipcode
   * @returns {*}
   */
  getZipAddress (zipcode) {
    return ApiClient().get(`/zipcodes/address`, {params: { zipcode }})
  }
}



// WEBPACK FOOTER //
// ./src/repositories/LibRepository.js